class CuriositiesVideo {
    constructor(module) {
        this.module = module
        this.videoContainer = this.module.querySelector('.curiosities-video-element')
        this.button = this.module.querySelector('.curiosities-video-button')
        this.youtubeId = this.videoContainer.dataset.youtubeId
        this.player = null

        this.init()
    }

    init() {
        // Add click listener to the button
        this.button.addEventListener('click', () => {
            if (!this.player) {
                this.loadVideo()
            }

            this.module.classList.add('is-playing')
        })
    }

    loadVideo() {
        // Initialize the YT Player
        this.player = new YT.Player(this.videoContainer, {
            height: '360',
            width: '640',
            videoId: this.youtubeId,
            events: {
                'onReady': (event) => event.target.playVideo()
            }
        })
    }
}

// Global YouTube API Ready Callback
function onYouTubeIframeAPIReady() {
    const sections = document.querySelectorAll('.curiosities-video')
    sections.forEach((section) => {
        new CuriositiesVideo(section)
    })
}

// Inject YouTube API Script
if (!window.YT && !document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
    const tag = document.createElement('script')
    tag.src = "https://www.youtube.com/iframe_api"
    const firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
}
